// Defoalt is for SECONDARY SCHOOLS API
export const environment = {
  baseUrl: 'https://api.ebill.so:5050/api',
  url: 'https://api.ebill.so:5050/',

  //gambool
  // baseUrl: 'https://api.ebill.so:3357/api',
  // url: 'https://api.ebill.so:3357/',
  production: true
};